/**
 * Policy-group sections — thin configurations over the shared
 * ChecklistPage (see checklist-page.tsx for the CRUD model).
 */
import { ChecklistPage } from "./checklist-page";

export { PolicyDetailsPage } from "./policy-details-page";

export function EndorsementsPage() {
    return (
        <ChecklistPage
            sectionId="endorsements"
            kind="endorsements"
            title="Policy Forms & Endorsements"
            subtitle="Select the endorsements, exclusions, and notices"
            withSearch
        />
    );
}

export function SubjectivitiesPage() {
    return (
        <ChecklistPage
            sectionId="subjectivities"
            kind="subjectivities"
            title="Subjectivities"
            subtitle="Track outstanding requirements before binding"
            selectAllAsRow
        />
    );
}
